package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordResponse(
    val message: String,
)

